export default __webpack_public_path__ + "static/media/click.1247473a.mp3";